import { useState } from 'react';

import {
  Grid,
  Typography,
  TextField,
  Button
} from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';

import { ViewerComponent } from '../commons/viewer/viewer.component';
import { createCategory } from '../../services/categories.service';

export const CategoriesCreateComponent = () => {

  const history = useHistory();

  const [category, setCategory] = useState({
    name: '',
    description: ''
  });

  const { enqueueSnackbar } = useSnackbar();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setCategory({
      ...category,
      [name]: value
    });
  }

  const goBack = () => {
    history.goBack();
  }

  const save = async () => {
    try {
      await createCategory(category);
      enqueueSnackbar(`${category.name} agregado`, {
        variant: 'success',
        resumeHideDuration: 3000,
        anchorOrigin:
          { horizontal: 'right', vertical: 'bottom' },
      });
      history.push('/categories');
    } catch (err) {
      enqueueSnackbar(JSON.stringify(err), {
        variant: 'error',
        resumeHideDuration: 6000,
        anchorOrigin:
          { horizontal: 'right', vertical: 'bottom' },
      });
    }
  }

  return (
    <ViewerComponent>
      <Grid container justifyContent="center" spacing={2}>
        <Grid item>
          <Typography variant="h3" alignt="center">
            Crear categoria
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <TextField
            id="name"
            name="name"
            fullWidth
            label="Nombre de la categoria"
            variant="outlined"
            required
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={10}>
          <TextField
            id="description"
            name="description"
            fullWidth
            label="Breve descripción de la categoria"
            variant="outlined"
            multiline
            minRows="3"
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={10}>
          <Grid container justifyContent="flex-end" spacing={2}>
            <Grid item>
              <Button
                variant="contained"
                color="default"
                startIcon={<ArrowBackIcon />}
                onClick={goBack}
              >
                Cancelar
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                startIcon={<SaveIcon />}
                onClick={save}
                disabled={!category.name}
              >
                Guardar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </ViewerComponent>
  )
}